import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=10dc6f24&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dc6f24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10dc6f24')) {
      api.createRecord('10dc6f24', component.options)
    } else {
      api.reload('10dc6f24', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=10dc6f24&scoped=true&", function () {
      api.rerender('10dc6f24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-206u2uNgBB1d0/JS/comp/Voucher-Unit.vue"
export default component.exports